import * as React from "react";
import {
  WithStyles,
  withStyles,
  StyleRulesCallback
} from "@material-ui/core/styles";

interface IProps {
  title?: string;
  className?: string;
}

const styles: StyleRulesCallback = ({ palette, breakpoints }) => ({
  errorMessageTitle: {
    marginTop: 300,
    fontSize: 36,
    textAlign: "center",
    [breakpoints.down("sm")]: {
      marginTop: 150,
      fontSize: 22,
      marginLeft: 20,
      marginRight: 20
    }
  },
  errorMessageSubtitle: {
    marginTop: 10,
    fontSize: 26,
    textAlign: "center",
    [breakpoints.down("sm")]: {
      fontSize: 14
    }
  },
  errorLink: {
    color: palette.common.black
  }
});

@(withStyles(styles) as any)
export default class ErrorMessage extends React.Component<
  IProps & Partial<WithStyles<any>>
> {
  public static defaultProps: IProps = {
    title: "Whoops, something went wrong."
  };

  public render() {
    const { classes, className, title } = this.props;
    return (
      <div className={[classes!.errorMessageTitle, className].join(" ")}>
        {title}
        <br />
        <span className={classes!.errorMessageSubtitle}>
          For any questions, please contact{" "}
          {
            <a className={classes!.errorLink} href="mailto:support@salaryo.com">
              customer support
            </a>
          }
          .
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorMessage/ErrorMessage.tsx